module.exports = __webpack_public_path__ + "961e7c00cb5ffb64c1a91f5a516ceb0c.pdf";